var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewPreOrder',{attrs:{"show":_vm.show,"show-client-select":!_vm.hasClientRole,"customers":_vm.customers,"designers":_vm.designers},on:{"update:show":function($event){return _vm.$emit('update:show', $event)},"addPreOrder":_vm.addNewPreOrder,"searchDesigners":_vm.executeSearchDesigners,"searchCustomers":_vm.executeSearchCustomers}})
}
var staticRenderFns = []

export { render, staticRenderFns }